import { ClassName } from 'types/props'

import { FIELDS } from '../constants'
import { Field, FieldProps } from '../field'
import { required } from '../validators'

const { id, label } = FIELDS.username

export interface UsernameField extends ClassName {
  username?: string
}

export const Username = (props: Partial<FieldProps>) => (
  <Field data-private id={id} label={label} type="text" validators={required} {...props} />
)
